import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

const CHAT_UI_MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  MatDialogModule,
  MatTooltipModule,
  MatDatepickerModule,
];

/**
 * The template vocabulary of the Internal Chat UI — SPEC-2026-09-internal-chat-pwa
 * (ADR-005).
 *
 * Chat templates are Bootstrap/Hyper markup plus a handful of Angular building blocks:
 * `translate`, `ngModel`/reactive forms, `matTooltip`, `mat-datepicker` (status expiry)
 * and `MatDialog`. This module is exactly that list — it replaces the product's
 * `SharedModule` in the chat declarations, which would drag charts, maps, editors and
 * dozens of product components into the standalone chat app's bundle.
 *
 * Declaration-free and provider-free: safe to import from any chat module, eager or lazy.
 */
@NgModule({
  imports: CHAT_UI_MODULES,
  exports: CHAT_UI_MODULES,
})
export class ChatUiModule { }
